import { render, staticRenderFns } from "./FullscreenGalleryItem.vue?vue&type=template&id=fa6b0ebc"
import script from "./FullscreenGalleryItem.vue?vue&type=script&lang=ts"
export * from "./FullscreenGalleryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCircularPreloader: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseCircularPreloader.vue').default})
